import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { getPortalTheme } from "@/lib/portalTheme";

export function ThemeForcer() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const forcedTheme = getPortalTheme(pathname);
    const root = document.documentElement;
    root.classList.remove("light", "dark");
    root.classList.add(forcedTheme);
    root.style.colorScheme = forcedTheme;
  }, [pathname]);

  return null;
}
